const header = document.querySelector('.site-header');
const updateHeights = () => {
  const root = document.documentElement;
  const secondaryNav = document.querySelector('.secondary-nav');
  root.style.setProperty('--header-height', `${header?.offsetHeight || 0}px`);
  root.style.setProperty('--second-nav-height', `${secondaryNav?.offsetHeight || 0}px`);
};
updateHeights();
window.addEventListener('resize', updateHeights);

const toggleOpenClass = (el, toggle) => {
  el.classList.toggle('is-open', toggle);
};
const removeOpenClass = (els) => els.forEach((el) => el.classList.remove('is-open'));

if (document.querySelector('.locations') || document.querySelector('.map-module')) {
  const mapElements = document.querySelectorAll('.map-init');
  const mapPins = document.querySelectorAll('.map-pin');
  const locationItems = document.querySelectorAll('.locations .location');
  const locationsBody = document.querySelector('.locations__list-inner');

  const initializeMap = (el, mapLat, mapLng, mapZoom, mapMobileZoom) => {
    const map = new google.maps.Map(el, {
      zoom: window.innerWidth < 768 ? Number(mapMobileZoom) : Number(mapZoom),
      center: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
      zoomControl: true,
      mapTypeControl: false,
      fullscreenControl: true,
      streetViewControl: false,
      scaleControl: true,
      disableDefaultUI: true,
      styles: [
        { elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
        { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#d0e4f3' }] },
        { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#e0e0e0' }] },
        { featureType: 'road', elementType: 'labels', stylers: [{ color: '#aaaaaa' }] },
        { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
        { featureType: 'poi.attraction', elementType: 'all', stylers: [{ visibility: 'on' }] },
        { featureType: 'poi.business', elementType: 'all', stylers: [{ visibility: 'off' }] },
        { featureType: 'landscape.natural.terrain', elementType: 'geometry', stylers: [{ color: '#f8f8f8' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#888888' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#ffffff' }] },
      ],
    });

    const popups = [];

    const centerMap = (lat, lng) => {
      const position = new google.maps.LatLng(Number(lat), Number(lng));
      map.panTo(position);
    };

    // Create popups from .map-pin
    mapPins.forEach((pin) => {
      const pinLat = pin.dataset.markerlat;
      const pinLng = pin.dataset.markerlng;
      const popupContent = pin.dataset.popup;
      const position = new google.maps.LatLng(pinLat, pinLng);

      if (popupContent) {
        const infoWindow = new google.maps.InfoWindow({ content: popupContent });
        infoWindow.setPosition(position);
        infoWindow.open(map);
        popups.push({ lat: pinLat, lng: pinLng, infoWindow, position });
      }
    });

    // Hover over .location → highlight + pan
    locationItems.forEach((item) => {
      item.addEventListener('mouseover', () => {
        const lat = item.dataset.markerlat;
        const lng = item.dataset.markerlng;
        const { index } = item.dataset;
        const match = popups.find((p) => p.lat === lat && p.lng === lng);

        if (match) {
          map.panTo(match.position);
          const allPopups = document.querySelectorAll('.map__popup');
          removeOpenClass([...allPopups, ...locationItems]);
          toggleOpenClass(item, true);

          const targetPopup = document.querySelector(`.map__popup[data-popup="${index}"]`);
          toggleOpenClass(targetPopup, true);
        }
      });
    });

    // Reset on mouse leave
    locationsBody?.addEventListener('mouseleave', () => {
      const allPopups = document.querySelectorAll('.map__popup');
      removeOpenClass([...allPopups, ...locationItems]);
      // centerMap(Number(mapLat), Number(mapLng));
    });

    // Click popup - highlight .location + center map
    google.maps.event.addListenerOnce(map, 'idle', () => {
      const allPopups = document.querySelectorAll('.map__popup');

      allPopups.forEach((popup) => {
        popup.addEventListener('click', () => {
          const popupId = popup.dataset.popup;
          if (!popupId) return;

          const targetLocation = document.querySelector(`.locations .location[data-index="${popupId}"]`);
          if (!targetLocation) return;

          const isAlreadyActive = targetLocation.classList.contains('is-open');
          removeOpenClass([...allPopups, ...locationItems]);

          if (!isAlreadyActive) {
            toggleOpenClass(targetLocation, true);
            toggleOpenClass(popup, true);

            // Center map on clicked popup
            const lat = targetLocation.dataset.markerlat;
            const lng = targetLocation.dataset.markerlng;
            centerMap(lat, lng);
          } else {
            centerMap(Number(mapLat), Number(mapLng));
          }
        });
      });
    });
  };

  // Initialize maps
  window.addEventListener('load', () => {
    setTimeout(() => {
      mapElements.forEach((el) => {
        initializeMap(el, el.dataset.lat, el.dataset.lng, el.dataset.zoom, el.dataset.mobileZoom);
      });
    }, 100);
  });
}
